import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AsmService } from '@spartacus/asm/core';
import { AsmAuthStorageService, AsmUi } from '@spartacus/asm/root';
import { BaseSiteService, GlobalMessageService, GlobalMessageType, OccEndpointsService, User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { LoactionStripService } from '../../../shared/modules/location-strip/loaction-strip.service';
import { VscaCsAgentAuthService } from '../../facade/vsca-csagent-auth.service';
import { VscaAsmComponentService } from '../../service/vsca-asm-component.service';
import { CustomAuthService } from '../../../custom-auth-service.service';

@Component({
    selector: 'vsca-cx-customer-emulation',
    templateUrl: './vsca-customer-emulation.component.html',
    styleUrls: ['./vsca-customer-emulation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VscaCustomerEmulationComponent implements OnInit, OnDestroy {
  customer: User;
  isCustomerEmulationSessionInProgress$: Observable<boolean>;
  private subscription = new Subscription();
  isCollapsed$: Observable<boolean>;
  protected startingCustomerSession = false;
  baseSiteId: string;
  isAsmEnabled: boolean;
  subscriptionRoute: Subscription;
  constructor(
    protected asmComponentService: VscaAsmComponentService,

    private asmService: AsmService,
    private csAgentAuthService: VscaCsAgentAuthService,
    private globalMessageService: GlobalMessageService,
    private locService: LoactionStripService,
    private authService: CustomAuthService,
    private baseSiteService: BaseSiteService,
    private router: Router, private asmAuthService: AsmAuthStorageService,
    private sharedService: SharedService,
    private occEndPoint: OccEndpointsService,
    private readonly user: UserAccountFacade,

  ) { }

  ngOnInit() {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
      })
    this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmEnabled = res ? res : false;
    });
    this.subscription.add(
      this.user.get().subscribe((user) => (this.customer = user))
    );
    this.isCustomerEmulationSessionInProgress$ =
      this.asmComponentService.isCustomerEmulationSessionInProgress();

    this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmEnabled = res ? res : false;
    });

    this.isCollapsed$ = this.asmService
      .getAsmUiState()
      .pipe(
        map((uiState: AsmUi) =>
          uiState.collapsed === undefined ? false : uiState.collapsed
        )
      );
  }

  logoutCustomer() {
    localStorage.clear();
    const baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    setTimeout(() => {
      window.location.href = `${baseUrl}/samlsinglesignon/saml?asm=true&site=${this.baseSiteId}`;
    }, 500);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionRoute?.unsubscribe();
  }

  startCustomerEmulationSession({ customerId }: { customerId?: string }): void {
    if (customerId) {
      this.csAgentAuthService.startCustomerEmulationSession(customerId);
      this.startingCustomerSession = true;
    } else {
      this.globalMessageService.add(
        { key: 'asm.error.noCustomerId' },
        GlobalMessageType.MSG_TYPE_ERROR
      );
    }
  }
}
